const PlaceholderImage = ({ width = 200, height = 200, text = 'Unavailable' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="#cccccc" />
      <text x="50%" y="50%" fontSize="20" textAnchor="middle" dy=".3em" fill="#777">
        {text}
      </text>
    </svg>
  );
};

export default PlaceholderImage;
